<template>
	<BaseModal
		:visible="visible"
		:title="$t('create_n', { name: $t('message') })"
		size="xl"
		:button-name="$t(props.data?.id ? 'save' : 'add')"
		:loading="state.loading"
		@close="emit('close')"
		@button-click="submit"
	>
		<div class="flex flex-col items-center p-6">
			<div class="grid w-full grid-cols-1 gap-6">
				<BaseTextInput
					type="textarea"
					theme-type="outlined"
					:placeholder="$t('message')"
					input-class="min-h-[80px]"
					:value="props.data?.message"
					@change="(v) => emit('update:data', { ...data, message: v } as DevTicketMessage)"
				/>
				<BaseImageUploader
					:name="$t('image')"
					class="w-full"
					:src="props.data?.image_thumb1"
					@uploading="(v) => (state.loading = v)"
					@change="changeImage"
				/>
				<BaseVideoUploader
					:name="$t('video')"
					class="w-full"
					:src="props.data?.video_path"
					@uploading="(v) => (state.loading = v)"
					@change="changeVideo"
				/>
			</div>
		</div>
	</BaseModal>
</template>

<script setup lang="ts">
import type { Image } from "~/models/image"
import type { Video } from "~/models/video"
import type { DevTicket, DevTicketMessage } from "~/models/dev-ticket"

const devTicketStore = useDevTicketStore()
const { $toast, $i18n, $toastErrors } = useNuxtApp()

const emit = defineEmits<{
	"update:ticket": [DevTicket]
	"update:data": [DevTicketMessage]
	done: [DevTicket]
	close: []
}>()

const props = defineProps<{
	visible: boolean
	ticket: DevTicket | null
	data: DevTicketMessage | null
}>()

const state = reactive({
	loading: false
})

const changeImage = (image: Image | null) => {
	emit("update:data", {
		...props.data,
		image_id: image?.id || null,
		image_path: image?.path || null,
		image_thumb1: image?.path_thumb1 || null,
		image_thumb2: image?.path_thumb2 || null
	} as DevTicketMessage)
}

const changeVideo = (video: Video | null) => {
	emit("update:data", {
		...props.data,
		video_id: video?.id || null,
		video_path: video?.path || null
	} as DevTicketMessage)
}

const submit = async () => {
	state.loading = true
	try {
		const ticket = await devTicketStore.createDevTicketMessage({
			company_id: props.ticket?.company_id || undefined,
			ticket_id: props.ticket?.id!,
			message: props.data?.message || "",
			image_id: props.data?.image_id,
			video_id: props.data?.video_id
		})
		$toast.success({
			message: $i18n.t("n_created", {
				name: $i18n.t("message")
			})
		})
		emit("done", ticket)
		emit("close")
	} catch (e) {
		$toastErrors(e)
	}
	state.loading = false
}
</script>
